// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1stD_","form":"styles_form__3MZPP"};